<!-- 产品图片 -->
<template>
    <div v-if="componentsData.type == 19"
        :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${bg_color};`"
    >
        <div class="swiper-container h100"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <Carousel class="h100" radius-dot :autoplay="componentsData.content.autoplay == 0 ? false : true"
                :autoplay-speed="componentsData.content.time * 1000"
            >
                <CarouselItem v-for="(item, index) of componentsData.content.imgList" :key="index"
                    :style="
                        componentsData.content.height_id == 1
                            ? 'height: 375px;'
                            : componentsData.content.height_id == 2
                            ? 'height: 187.5px;'
                            : componentsData.content.height_id == 3
                            ? 'height: 281.25px;'
                            : componentsData.content.height_id == 4
                            ? 'height: 500px;'
                            : componentsData.content.height_id == 5
                            ? 'height: 750px;'
                            : 'height: 375px;'
                    "
                >
                    <img class="w100" :src="item.picview"
                        :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
                    />
                </CarouselItem>
            </Carousel>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        bg_color: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    height: 150px;
}
.h100 {
    height: 100%;
}
.w100 {
    width: 100%;
    height: 100%;
}
</style>